<template>
  <div>
    <main-layout>
      <div class="px-5">
        <template>
          <div>
            <v-tabs v-model="active" slider-color="primary">
              <v-tab v-for="(tab, i) in tabs" :key="i" ripple>
                {{ tab.label }}
              </v-tab>
              <v-tab-item :key="0">
                <dashboard v-if="active === 0"> </dashboard>
              </v-tab-item>
              <v-tab-item :key="1" class="mt-5">
                <setting v-if="active === 1"></setting>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
      </div>
    </main-layout>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import dashboard from './Dashboard.vue'
import setting from './Setting.vue'

export default {
  components: {
    dashboard,
    setting
  },
  data() {
    return {
      search: '',
      active: null,
      tabs: [
        {
          label: this.$t('admin_dashboard')
        },
        {
          label: this.$t('Setting')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({})
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/main.vue